import { PositionObject, TooltipPositionerPointObject } from 'highcharts';

import { TOOLTIP_PADDING_SIZE } from '../../../constants';

/**
 * Make Tooltip follow mouse pointer x position, y position is set to Point's top edge.
 * Need to have `tooltip.followPointer: true` to work.
 */
export function positioner(
  tooltipWidth: number,
  tooltipHeight: number,
  point: TooltipPositionerPointObject
): PositionObject {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { chart } = this; // `this` is of type `TooltipOptions`
  const yAxis = chart.hoverPoint;

  const { chartPosition } = chart.pointer;
  const { xAxis } = chart.hoverSeries;

  const magicBackgroundTransformValue = 6; // Origin from the library

  let x = chartPosition.left + xAxis.left + point.plotX - tooltipWidth / 2 - magicBackgroundTransformValue;

  // no need to check if "x < 0" as there is big enough content of y axis, so the x should be always > 0

  if (x + tooltipWidth + TOOLTIP_PADDING_SIZE > window.innerWidth) {
    // prevent overflow out of the body content from right side
    x = window.innerWidth - tooltipWidth - TOOLTIP_PADDING_SIZE;
  }

  return {
    x,
    y: chartPosition.top + xAxis.top + yAxis.plotY - yAxis.pointWidth - tooltipHeight,
  };
}
